import React, { Component } from "react";
import { Button, Form, FormGroup, Label, Input, Col, Row } from 'reactstrap';
import BlockUi from 'react-block-ui';
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import * as hopDongAction from './actions'
import * as hopDongConstant from './constants'
import { storedb } from '../../views/client/storedb'
import { ButtonExt } from "../controls/ButtonExt"
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { currentDate, parseDatetime } from "../../lib/common";

class HopDongEdit extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      item: {
        HopDongId: 0,
        TenHopDong: "",
        TuNgay: currentDate(),
        DenNgay: currentDate().add(10, 'years'),
        KhachHangId: 0,
        TrangThai: 0,
        ChietKhau: 0,
        TongGiaTri: 0,
        GhiChu: ""
      },
      KhachHangId: 0,
      formError: {},
      formValid: false,
      stores_id: dbContext.getStoreId(),
    };
  }
  convertToMoment = (date) => {
    if (typeof date == 'string') {
      return moment(date);
    }
    return date;
  }
  getParam = (name) => {
    const queryParamsString = this.props.location.search.substring(1),
      searchParams = new URLSearchParams(queryParamsString);
    return searchParams.get(name);
  }
  handleDateChange = (name, obj) => {
    let { item } = this.state;
    switch (name) {
      case "TuNgay":
        item.TuNgay = obj.format();
        item.DenNgay = obj.add(10, 'years').format()
        break;
      case "DenNgay":
        item.DenNgay = obj.format();
        break;
      default:
        break;
    }
    this.setState({ item })
  }
  handleControlChangeTrim = (e) => {
    let { item } = this.state
    item[e.target.name] = e.target.value.trim()
    this.setState({ item })
  }
  handleControlChange = (e) => {
    let { item } = this.state
    item[e.target.name] = e.target.value
    this.setState({ item })
  }
  handleSelectChange = (name, selectedOption) => {
    let { item } = this.state;
    switch (name) {
      case "TrangThai":
        item.TrangThai = selectedOption.target.value
        break;
      default:
        break;
    }
    this.setState({ item })
  }
  Cancel = () => {
    this.featchDetail();
  }
  featchDetail = () => {
    const { hopDongDetailRequest } = this.props
    let hopDongId = this.getParam("id");
    var requestData = {
      hopDongId: hopDongId || 0,
      khachHangId: this.state.KhachHangId
    }
    return hopDongDetailRequest(requestData);
  }
  UpdatehopDong = () => {
    let formError = {};
    let formValid = true;
    if (!this.state.item.TenHopDong || this.state.item.TenHopDong == "") {
      formError.TenHopDong = 'Bạn chưa nhập tên hợp đồng';
    }
    if (!this.state.item.TuNgay || this.state.item.TuNgay == "") {
      formError.TuNgay = 'Bạn chưa nhập ngày bắt đầu';
    }
    if (!this.state.item.DenNgay || this.state.item.DenNgay == "") {
      formError.DenNgay = 'Bạn chưa nhập ngày kết thúc';
    }
    if (!this.state.item.ChietKhau || this.state.item.ChietKhau == "") {
      formError.ChietKhau = 'Bạn chưa nhập % chiết khấu';
    }
    if (!this.state.item.TongGiaTri || this.state.item.TongGiaTri == "") {
      formError.TongGiaTri = 'Bạn chưa nhập tổng giá trị';
    }
    for (var prp in formError) {
      if (prp && formError[prp] != '') {
        formValid = false;
        break;
      }
    }
    this.setState({ formError, formValid });
    if (formValid) {
      let { item } = this.state
      item.KhachHangId = this.state.KhachHangId
      this.props.hopDongUpdateRequest(item);
    }
  }
  BackToListHopDong = () => {
    this.props.history.push('/hopdong?kid=' + this.state.KhachHangId);
  }
  componentDidMount() {
    let khachHangId = this.getParam("kid");
    if (khachHangId && khachHangId > 0) {
      this.setState({ KhachHangId: khachHangId }, () => {
        let hopDongId = this.getParam("id");
        if (hopDongId && hopDongId > 0) {
          this.featchDetail();
        }
      })
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.hopDongEdit.type == hopDongConstant.HOPDONG_DETAIL_SUCCESS) {
      let { item } = nextProps.hopDongEdit;
      if (item.Id && item.Id > 0) {
        this.setState({
          item: item
        });
      }
    } else if (nextProps.hopDongEdit.type == hopDongConstant.HOPDONG_UPDATE_SUCCESS) {
      this.BackToListHopDong()
    }
  }
  render() {
    const { formError, item } = this.state;
    const {
      hopDongEdit: {
        isRequesting,
        requesting,
        errors,
        messages
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={requesting} >
          <Form className="row">
            <FormGroup className="col-sm-4">
              <Label >Tên/Số hợp đồng<require><span className="text-danger">(*)</span></require></Label>
              <Input type="text" name="TenHopDong" placeholder="Tên/Số hợp đồng" value={item.TenHopDong || ''} onChange={this.handleControlChangeTrim.bind(this)} />
              <em className="error invalid-feedback">{formError.TenHopDong}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <div><Label >Từ ngày  <span className="text-danger">(*)</span></Label></div>
              <DatePicker name="TuNgay" dateFormat="DD/MM/YYYY" selected={this.convertToMoment(item.TuNgay)} onChange={this.handleDateChange.bind(this, "TuNgay")} className={"form-control"} />
              <em className="error invalid-feedback">{formError.TuNgay}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <div><Label >Đến ngày  <span className="text-danger">(*)</span></Label></div>
              <DatePicker name="DenNgay" dateFormat="DD/MM/YYYY" selected={this.convertToMoment(item.DenNgay)} onChange={this.handleDateChange.bind(this, "DenNgay")} className={"form-control"} />
              <em className="error invalid-feedback">{formError.DenNgay}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label >Chiết khấu<require><span className="text-danger">(*)</span></require></Label>
              <Input type="text" name="ChietKhau" placeholder="Chiết khấu" value={item.ChietKhau || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.ChietKhau}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label >Tổng giá trị<require><span className="text-danger">(*)</span></require></Label>
              <Input type="text" name="TongGiaTri" placeholder="Tổng giá trị" value={item.TongGiaTri || ''} onChange={this.handleControlChangeTrim.bind(this)} />
              <em className="error invalid-feedback">{formError.TongGiaTri}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label>Trạng thái<span className="text-danger">(*)</span></Label>
              <select name="TrangThai" className="form-control" value={item.TrangThai || -1} onChange={this.handleSelectChange.bind(this, "TrangThai")}>
                <option value={-1}>---Chọn trạng thái---</option>
                <option value={1}>Có hiệu lực</option>
                <option value={0}>Hết hiệu lực</option>
              </select>
              <em className="error invalid-feedback">{formError.TrangThai}</em>
            </FormGroup>
            <FormGroup className="col-sm-12">
              <Label for="descriptionText">Ghi chú</Label>
              <Input type="textarea" name="GhiChu" className="form-control" value={item.GhiChu || ''} onChange={this.handleControlChange.bind(this)} />
            </FormGroup>
          </Form>
          <div className="w-100 mb-2">
            <ButtonExt btnClass="mr-1"
              color="success"
              iconClass="fa-list"
              displayText="Danh sách"
              btnClick={() => this.BackToListHopDong()}
              permission={""} />
            <ButtonExt btnClass="mr-1"
              color="primary"
              iconClass="fa-save"
              displayText="Lưu"
              btnClick={() => this.UpdatehopDong()}
              permission={""} />
          </div>
        </BlockUi>
        <Row>
          <Col md="12">
            {!isRequesting && !!errors.length && (
              <Errors errors={errors} />
            )}
            {!isRequesting && !!messages.length && (
              <Messages messages={messages} />
            )}
          </Col>
        </Row>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  hopDongEdit: state.hopDongEdit,
})
const connected = connect(mapStateToProps, {
  hopDongDetailRequest: hopDongAction.hopDongDetailRequest,
  hopDongUpdateRequest: hopDongAction.hopDongUpdateRequest,
  hopDongListRequest: hopDongAction.hopDongListRequest,
})(HopDongEdit)

const formed = reduxForm({
  form: 'hopDongEdit',
})(connected)

export default formed;


// WEBPACK FOOTER //
// ./src/views/HopDong/HopDongEdit.js